<div class="pi-dashboard--pageNotFound forbiddenDashboardDescription">
    <ng-container dashboard-body>
        <ng-container dashboard-body>
            <div class="pageNotFoundDescription">
                <div class="ico-moon ico-moon-spam color-silver"></div>

                <div class="pageNotFoundDescription_mainLine">
                    {{ TR.key('design.noAccess.header') }}
                </div>
                <div class="pageNotFoundDescription_secondaryLine">
                    {{ TR.key('design.noAccess.subheader') }}
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
